
import { createAction, props } from '@ngrx/store';
import { ProgramacionCorreoDto } from '../administracion/data/programacionCorreoDto';




export const addProgramacionCorreo = createAction(
  '[ADD PROGRAMACION CORREO] ',
  props<{ _newProgramacionCorreoDto: ProgramacionCorreoDto }>()
);

export const removeProgramacionCorreo = createAction(
  '[REMOVE PROGRAMACION CORREO]',
);











